<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">通信资源详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="通信资源名称" prop="ResourceName" style="display:inline-block;">
          <el-input v-model="ruleForm.ResourceName" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="通信资源类型" prop="CommunicationResourcesType" style="display:inline-block;">
          <el-select
            v-model="ruleForm.CommunicationResourcesType"
            placeholder="请选择通信资源类型"
            v-bind:disabled="IsEdit"
            style="width:50rem;"
          >
            <el-option
              v-for="item in options"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="Address" style="display:inline-block;">
          <el-input v-model="ruleForm.Address" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="Longitude" style="display:inline-block;">
          <el-input v-model="ruleForm.Longitude" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="Latitude" style="display:inline-block;">
          <el-input v-model="ruleForm.Latitude" style="width:45rem;" v-bind:disabled="IsEdit"></el-input>
          <ZjLngLatSelect :point_lat="ruleForm.Latitude" :point_lng="ruleForm.Longitude" :disabled="IsEdit"
            style="margin-left:0.5rem" @onGotLngLat="onGotLngLat"></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="联系人" prop="Contact" style="display:inline-block;">
          <el-input v-model="ruleForm.Contact" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="联系人移动电话" prop="Phone" style="display:inline-block;">
          <el-input v-model="ruleForm.Phone" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="值班电话" prop="DutyTel" style="display:inline-block;">
          <el-input v-model="ruleForm.DutyTel" style="width:50rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark" style="display:inline-block;">
          <el-input
            type="textarea"
            style="width:118rem;"
            v-model="ruleForm.Remark"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer>
      <div class="right" style="width:134rem;text-align:center;padding:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjCommunicationresourcesinfo",
  controller: "EmergencyResource",
  action: "Communicationresourcesinfo",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm: {
        ResourceName: "",
        CommunicationResourcesType: "",
        Address: "",
        Longitude: "",
        Latitude: "",
        Contact: "",
        Phone: "",
        DutyTel: "",
        Remark: ""
      },
      options: [],
      rules: {
        ResourceName: [
          { required: true, message: "通信资源名称", trigger: "blur" },
        ],
        Address: [
          { required: true, message: "请输入地址", trigger: "blur" },
        ],
        Longitude: [
          { required: true, message: "请输入经度", trigger: "blur" },
        ],
        Latitude: [
          { required: true, message: "请输入纬度", trigger: "blur" },
        ],

        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          ResourceName: "",
          CommunicationResourcesType: "",
          Address: "",
          Longitude: "",
          Latitude: "",
          Contact: "",
          Phone: "",
          DutyTel: "",
          Remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:CommunicationResourcesType:", "")
      ])
      .then(r => {
        this.options = r[0].JValue;
        this.loading = false;
        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    search() {
      let ResourcesId = this.query.obj;
      if (ResourcesId != null && ResourcesId != "") {
        let searchInfo = {
          ResourcesId: ResourcesId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.loading = true;
        this.loadingText = '加载中...';
        new MyApis.CommunicationresourcesApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            //console.log(r);
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm(formName) {
      this.ruleForm = formName;
      //this.$refs[formName].resetFields();
      this.query.obj = null;
    },
    save() {
      this.ruleForm.Longitude = parseFloat(this.ruleForm.Longitude);
      this.ruleForm.Latitude = parseFloat(this.ruleForm.Latitude);
      if (this.query.obj == null) {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.CommunicationresourcesApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "通讯资源添加";
            this.logInfo.LogMessage = r ? "通讯资源添加成功" : "通讯资源添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "通讯资源管理详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.CommunicationresourcesApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "通讯资源修改";
            this.logInfo.LogMessage = r ? "通讯资源修改成功" : "通讯资源修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "通讯资源管理详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>